<template>
    <div class="select-profile">
        <div class="container">
            <span class="select-profile__title">
                <IconSpeaker class="select-profile__speaker" @click="speechSynthesis(text)"></IconSpeaker>{{ text }}
            </span>

            <div class="select-profile__list">
                <div v-for="(subp, index) in subProfilesList" :key="index" class="select-profile__item" @click="selectSubprofile(subp)">
                    <img class="select-profile__avatar" :src="getAvatar(subp.avatar)"/>
                    <span class="select-profile__name">{{ subp.name }}</span>
                </div>

                <div class="select-profile__item" @click="selectSubprofile()">
                    <IconParent class="select-profile__avatar"></IconParent>
                    <span class="select-profile__name">Rodzic</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { useCookies } from "vue3-cookies";
import IconSpeaker from "../elements/icons/IconSpeaker.vue";
import { parseImageUrl } from '../../mixins/useParseImage';
import IconParent from "../elements/icons/IconParent.vue";

const { cookies } = useCookies();

export default {
    name: "ProfileSelect",
    mixins: [parseImageUrl],
    components: {
        IconSpeaker,
        IconParent
    },
    data() {
        return {
            SUBPROFILE_SELECT: ' /api/krainaabc/subprofile/select?device=www',
            SUBPROFILE_UNSELECT: ' /api/krainaabc/subprofile/unselect?device=www',
            text: 'Kto się dzisiaj bawi?'
        };
    },
    watch: {
        subProfilesList(value) {
            if(value && value.length) {
                this.selectedProfile = value[0]._id;
            }
        }
    },
    computed: {
        globalUserData() {
            return this.$store.getters.getGlobalUserData;
        },
        subProfilesList() {
            return this.$store.getters.getSubProfiles;
        },
        gemiusIdentifier() {
            return this.$store.getters.getGemiusIdentifier;
        }   
    },
    methods: {
        getAvatar(img) {
            let url = '';
            if (img && img.url) {
                url = parseImageUrl(img.url,186,186);
            } else {
                return null;
            }
            return url;
        },
        selectSubprofile(subProfile) {
            if(subProfile && subProfile._id) {
                if(subProfile.has_pin) {
                    this.$store.dispatch("changePinLockChild", { subProfile, mode: 'unlock' });
                } else {
                    let data = {};
                    data['id'] = subProfile._id;

                    axios
                        .post(this.SUBPROFILE_SELECT, data)
                        .then(() => { 
                            this.$store.dispatch("activeSubProfile");  

                            this.$router.push({
                                path: this.$route.params && this.$route.params.from ? this.$route.params.from : "/",
                            });                               
                        })
                        .catch((error) => {
                            console.log(error);
                        });
                }
            } else {
                if (!cookies.get("TVP_MNG_SUBPROFILE")) {
                    this.$router.push({
                        name: "Categories",
                        path: "/",
                    });  
                } else {
                    this.$store.dispatch("changePinLock", { isOpen: true, path: this.$route.params && this.$route.params.from });
                }
            } 
        }      
    },
    mounted() {
        window.gemius_event(
            '_view_',
            this.gemiusIdentifier
        );   
    }
};
</script>